import { apiClient } from "./authService";

export type PromoType = "PERCENT" | "FIXED";

export interface PromoPayload {
  code: string;
  type: PromoType;
  value: number;
  max_usage?: number;
  max_usage_per_client?: number;
  start_date?: string;
  expiry?: string;
  active?: boolean;
}

export const createPromo = async (payload: PromoPayload) => {
  const res = await apiClient.post("/promo/create", payload);
  return res.data;
};

export const fetchPromos = async () => {
  const res = await apiClient.get("/promo/all");
  return res.data;
};

export const fetchPromo = async (id: string) => {
  const res = await apiClient.get(`/promo/${id}`);
  return res.data;
};

export const updatePromo = async (id: string, payload: Partial<PromoPayload>) => {
  const res = await apiClient.patch(`/promo/update/${id}`, payload);
  return res.data;
};

export const deletePromo = async (id: string) => {
  const res = await apiClient.delete(`/promo/delete/${id}`);
  return res.data;
};
